import React from 'react';
import AboutTemplate from './AboutTemplate';
import { platformData } from './platformData';

const NewbornRiskAbout = () => {
  return (
    <AboutTemplate 
      {...platformData.newbornrisk}
      platformKey="newbornrisk"
    />
  );
};

export default NewbornRiskAbout; 